import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../shared/components/form-controls/validators/validation.service';

@Component({
  selector: 'tax-input-page',
  templateUrl: './input-page.component.html',
  styleUrls: ['./input-page.component.sass'],
})
export class InputPageComponent implements OnInit {
  phoneModel = '12';
  phone = new UntypedFormControl('2', [this.validationService.phoneValidator()]);
  phone2 = new UntypedFormControl('2', []);

  nameModel = 'Имя';
  passwordModel = 'Имя';

  password = new UntypedFormControl('23', [Validators.required, this.validationService.isPasswordStrength]);

  input = new UntypedFormControl('23', [Validators.required, this.validationService.isPasswordStrength]);
  form: UntypedFormGroup = this.fb.group({
    password: ['Имя', [Validators.required, this.validationService.isPasswordStrength]],
  });

  user = {
    email: '',
    kkmGroupsPermissions: [],
    permissions: [],
    retailPlaces: [],
    groupsIds: [],
    phone: '',
    position: '',
    name: '',
  };

  isPasswordStrength = this.validationService.isPasswordStrength;

  constructor(
    private fb: UntypedFormBuilder,
    private validationService: ValidationService,
  ) { }

  ngOnInit(): void {
    this.input.valueChanges
      .pipe()
      .subscribe((val) => {
        console.log(val);
      });

    this.form.valueChanges
      .pipe()
      .subscribe((val) => {
        console.log(val);
      });
  }
}
